import {
  GET_HIPPODROMES_BETS,
  GET_HIPPODROMES_BETS_SUCCESS,
  GET_HIPPODROMES_BETS_FAILURE,
  SET_SELECTED_BET_TYPE,
  SET_SELECTED_RACE_NUMBER
} from 'Store/constants';

const initialState = {
  data: [],
  selectedBetTypeId: null,
  selectedRaceNumber: null,
  isLoading: null,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_HIPPODROMES_BETS:
      return { ...state, isLoading: true, error: null };
    case SET_SELECTED_BET_TYPE:
      return { ...state, selectedBetTypeId: action.payload };
    case SET_SELECTED_RACE_NUMBER:
      return { ...state, selectedRaceNumber: action.payload };
    case GET_HIPPODROMES_BETS_SUCCESS:
      return { ...state, data: action.payload, isLoading: false, error: null };
    case GET_HIPPODROMES_BETS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};